import GutterContainer from './GutterContainer';
import { TabsContext } from '../utils/TabsContext';
import UITabs from 'UIComponents/nav/UITabs';
import { jsx as _jsx } from "react/jsx-runtime";
const MdxTabs = ({
  size = 'large',
  defaultSelected,
  children
}) => /*#__PURE__*/_jsx(GutterContainer, {
  size: size,
  children: /*#__PURE__*/_jsx(TabsContext.Provider, {
    value: true,
    children: /*#__PURE__*/_jsx(UITabs, {
      defaultSelected: defaultSelected,
      children: children
    })
  })
});
export default MdxTabs;